<div class="authentication-component" [ngClass]="{'mox-style': claim.isMox()}">
    <div class="col-12">
        <qnect-notification-messages [notifications]="notifications"></qnect-notification-messages>
        <h5>{{ 'motorClaim.getStarted.heading' | translate }}</h5>
        <span *ngIf="transactionInfo.isTravelProduct() || transactionInfo.isAccidentProduct()">
         <p>{{ 'pageGetStarted.heading.desc' | translate }}</p>
      </span>
        <span *ngIf="transactionInfo.isDomesticHelperProduct()">
         <p>{{ 'pageGetStarted.heading.dmhDesc' | translate }}</p>
      </span>
        <span *ngIf="transactionInfo.isMotorProduct()">
         <p>{{ 'motorClaim.getStarted.description' | translate }}</p>
      </span>
        <span *ngIf="transactionInfo.isGenericClaim() || transactionInfo.isHomeProduct() || transactionInfo.isEmployeeCompensationProduct()">
         <p>{{ 'pageGetStarted.heading.genericInstruction' | translate }}</p>
      </span>
    </div>
    <div class="row col-12 get-started-form">
        <div class="col-lg-9 col-md-12">
            <div class="form-group">
                <qnect-ui
                    #VDR17_POLICY_NUMBER
                    [fieldId]="'VDR17_POLICY_NUMBER'"
                    [formGroup]="policyAuthenticationModel"
                    [disabled]="'true'"
                    [dynamicLabel]="this.isNotNullOrUndefinedStr(claim.getIsCoverNotePreNumbered()) ?
                    'motorClaim.homePage.coverNote' : 'anotherInsuranceSection.policyNumber'"
                    name="policyNumber"
                ></qnect-ui>
            </div>
            <div class="form-group">
                <qnect-ui
                    #TRAVEL_OTH_01_INCIDENT_DATE
                    [fieldId]="'TRAVEL_OTH_01_INCIDENT_DATE'"
                    [formGroup]="policyAuthenticationModel"
                    [dynamicLabel]="'domesticHelperClaim.dateOfLoss'"
                    name="otherDateOfIncident"
                ></qnect-ui>
            </div>
            <ng-container *ngIf="transactionInfo.isTravelProduct() && transactionInfo.getRealCountry() === 'HKG'">
                <form>
                    <ul class="nav nav-tabs ff-stag">
                        <li>
                            <a data-bs-toggle="tab"
                               href="#nameDiv"
                               (click)="resetFields('fullname')"
                               [ngClass]="{'active': this.transactionInfo.getDateOfBirth() == null && this.transactionInfo.getDateOfBirth() == undefined}">
                                {{ 'pageGetStarted.body.name' | translate }}</a>
                        </li>
                        <li>
                            <a data-bs-toggle="tab"
                               href="#birthDiv"
                               (click)="resetFields('dateofbirth')"
                               [ngClass]="{'active': this.transactionInfo.getDateOfBirth() != null && this.transactionInfo.getDateOfBirth() != undefined}">
                                {{ 'pageGetStarted.body.dateOfBirth' | translate }}</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div id="nameDiv" class="tab-pane fade in active show">
                            <div class="form-group">
                                <qnect-ui
                                    #B2C02Name
                                    [formGroup]="policyAuthenticationModel"
                                    [fieldId]="'B2C02Name'"
                                    name="name"
                                ></qnect-ui>
                            </div>
                        </div>
                        <div id="birthDiv" class="tab-pane fade">
                            <div class="form-group">
                                <qnect-ui
                                    #B2C03DateOfBirth
                                    [formGroup]="policyAuthenticationModel"
                                    [fieldId]="'B2C03DateOfBirth'"
                                    name="dateOfBirth"
                                ></qnect-ui>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="transactionInfo.isDomesticHelperProduct()">
                <form>
                    <ul class="nav nav-tabs ff-stag">
                        <li>
                            <a data-bs-toggle="tab"
                               href="#helperNameDiv"
                               (click)="resetFields('fullname')"
                               [ngClass]="{'active': this.transactionInfo.getAuthIdNumber() == '' || this.transactionInfo.getAuthIdNumber() == null}">
                                {{ 'pageGetStarted.body.dmhName' | translate }}</a>
                        </li>
                        <li>
                            <a data-bs-toggle="tab"
                               href="#hkidDiv"
                               (click)="resetFields('idNumber')"
                               [ngClass]="{'active': this.transactionInfo.getAuthIdNumber() != null && this.transactionInfo.getAuthIdNumber() != ''}">
                                {{ 'pageGetStarted.body.dmhHkidPassport' | translate }}</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div id="helperNameDiv" class="tab-pane fade in active show">
                            <div class="form-group">
                                <qnect-ui
                                    #DMH_AUTH_NAME
                                    [formGroup]="policyAuthenticationModel"
                                    [fieldId]="'DMH_AUTH_NAME'"
                                    name="name"
                                ></qnect-ui>
                            </div>
                        </div>
                        <div id="hkidDiv" class="tab-pane fade">
                            <div class="form-group">
                                <qnect-ui
                                    #DMH_AUTH_HELPER_ID
                                    [formGroup]="policyAuthenticationModel"
                                    [fieldId]="'DMH_AUTH_HELPER_ID'"
                                    name="idNumber"
                                ></qnect-ui>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="transactionInfo.isMotorProduct()">
                <form>
                    <div class="form-group">
                        <qnect-ui
                            #MOTOR_AUTH_NAME
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'MOTOR_AUTH_NAME'"
                            name="name"
                        ></qnect-ui>
                    </div>
                    <div class="form-group">
                        <qnect-ui
                            #MOTOR_AUTH_REG_NUMBER
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'MOTOR_AUTH_REG_NUMBER'"
                            name="idNumber"
                        ></qnect-ui>
                    </div>
                </form>
            </ng-container>
            <!-- sgp, mys  -->
            <ng-container *ngIf="transactionInfo.getRealCountry() !== 'HKG'">
                <form>
                    <div class="form-group">
                        <qnect-ui
                            #GENERIC_AUTH_NAME
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'GENERIC_AUTH_NAME'"
                            name="name"
                            [dynamicLabel]="transactionInfo.isGenericClaim() ? 'pageGetStarted.body.genericHolderName' : ''"
                            [uiPopover]="uiPopover"
                        ></qnect-ui>
                    </div>
                    <div class="form-group">
                        <qnect-ui
                            #GENERIC_ID_NUMBER
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'GENERIC_ID_NUMBER'"
                            name="idNumber"
                        ></qnect-ui>
                    </div>
                </form>
            </ng-container>
            <!-- hkg - generic, home and personal accident -->
            <ng-container *ngIf="transactionInfo.getRealCountry() === 'HKG' && (transactionInfo.isGenericClaim() ||
                transactionInfo.isHomeProduct() || transactionInfo.isAccidentProduct())">
                <form>
                    <div class="form-group">
                        <qnect-ui
                            #GENERIC_AUTH_NAME
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'GENERIC_AUTH_NAME_BOTH'"
                            name="name"
                            [dynamicLabel]="transactionInfo.isGenericClaim() ? 'pageGetStarted.body.genericHolderName' : ''"
                            [uiPopover]="uiPopover"
                        ></qnect-ui>
                    </div>
                    <div class="form-group">
                        <qnect-ui
                            #GENERIC_ID_NUMBER
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'GENERIC_ID_NUMBER'"
                            name="idNumber"
                        ></qnect-ui>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="transactionInfo.isEmployeeCompensationProduct()">
                <form>
                    <div class="form-group">
                        <qnect-ui
                            #EC_AUTH_NAME
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'EC_AUTH_NAME'"
                            name="name"
                        ></qnect-ui>
                    </div>
                    <div class="form-group">
                        <qnect-ui
                            #EC_AUTH_ID
                            [formGroup]="policyAuthenticationModel"
                            [fieldId]="'EC_AUTH_ID'"
                            name="idNumber"
                        ></qnect-ui>
                    </div>
                </form>
            </ng-container>
        </div>
        <div class="col-lg-3 col-xl-3 col-md-12"></div>
    </div>
    <div class="submit-bar">
        <abandon-button></abandon-button>
        <button (click)="goToNext()" class="btn btn-primary float-right new-btn">
            {{ 'pageGetStarted.button' | translate }} <i class="fas fa-arrow-right"></i>
        </button>
    </div>
</div>

<ng-template #acknowledgement_modal let-c="close" let-d="dismiss">
    <div class="modal-body acknowledgement-modal">
        <h4 class="modal-title">{{'paClaim.acknowledgement.popupTitle' | translate}}</h4>
        <br/>
        <div class="policy-details-block">
            <div class="policy-details-row">
                <span class="detail-title">{{ 'paClaim.acknowledgement.policyHolder' | translate}}</span>
                <span class="detail-desc">{{claim.getPolicyHolderName()}}</span>
            </div>
            <div class="policy-details-row">
                <span class="detail-title">{{ 'paClaim.acknowledgement.policyNumber' | translate}}</span>
                <span class="detail-desc">{{claim.getPolicyNumber()}}</span>
            </div>
        </div>
        <div class="acknowledgement-modal-text">
            <p>{{'paClaim.acknowledgement.content' | translate}}</p>
        </div>
        <div class="footer acknowledgement-modal-footer">
            <button (click)="acknowledge()" class="btn btn-primary new-btn">
                {{ 'paClaim.acknowledgement.acknowledgeContinue' | translate}}
            </button>
            <a href="{{entryUrl}}" class="btn btn-secondary new-btn"
            >{{ 'claimSection.generalLabels.generalButtonLabels.cancel' | translate }}</a
            >
        </div>
    </div>
</ng-template>
